import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 pt-20 pb-12">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-6">
            <p className="overline text-white/55">The I Choose Movement</p>
            <h2 className="display mt-4 text-white text-[44px] md:text-[68px]">
              It's not too late <br className="hidden md:block" /> to choose you.
            </h2>
            <p className="font-sans text-white/65 mt-6 max-w-md text-[15px] leading-relaxed">
              Founded by Crystal Purdue. A community of people choosing to be participants in
              their own lives &mdash; creating the lives they want to live, on purpose.
            </p>
            <div className="flex flex-wrap gap-3 mt-8">
              <Link to="/speaking#inquiry" data-testid="footer-cta-speak" className="btn-ghost border-white text-white hover:bg-white hover:text-black">
                Book Crystal to Speak <ArrowUpRight size={16} />
              </Link>
              <a href={BRAND.calendly} target="_blank" rel="noreferrer" data-testid="footer-cta-coach" className="btn-ghost border-white text-white hover:bg-white hover:text-black">
                Book a Consultation
              </a>
            </div>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <p className="overline text-white/55">Explore</p>
            <ul className="mt-6 space-y-3 text-[15px]">
              <li><Link to="/about" className="text-white/80 hover:text-white">About Crystal</Link></li>
              <li><Link to="/speaking" className="text-white/80 hover:text-white">Speaking</Link></li>
              <li><Link to="/workshops" className="text-white/80 hover:text-white">Workshops</Link></li>
              <li><Link to="/coaching" className="text-white/80 hover:text-white">Coaching</Link></li>
              <li><Link to="/shop" className="text-white/80 hover:text-white">Shop</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-4">
            <p className="overline text-white/55">Contact</p>
            <ul className="mt-6 space-y-2 text-[15px] text-white/80">
              <li>{BRAND.founder}</li>
              <li>{BRAND.city}</li>
              <li><a href={`tel:${BRAND.phone}`} className="hover:text-white">{BRAND.phone}</a></li>
              <li><a href={`mailto:${BRAND.email}`} className="hover:text-white">{BRAND.email}</a></li>
              <li><a href={`https://${BRAND.domain}`} className="hover:text-white">{BRAND.domain}</a></li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a aria-label="Instagram" href={BRAND.social.instagram} target="_blank" rel="noreferrer" className="p-2 border border-white/30 hover:border-white"><Instagram size={16} /></a>
              <a aria-label="TikTok"    href={BRAND.social.tiktok}    target="_blank" rel="noreferrer" className="p-2 border border-white/30 hover:border-white"><Music2 size={16} /></a>
              <a aria-label="Facebook"  href={BRAND.social.facebook}  target="_blank" rel="noreferrer" className="p-2 border border-white/30 hover:border-white"><Facebook size={16} /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[12px] tracking-[0.18em] uppercase text-white/55">
          <span>© {new Date().getFullYear()} The I Choose Movement</span>
          <span>One choice can change your life.</span>
        </div>
      </div>
    </footer>
  );
}
